const formatPrice = (price) => {
  if (typeof price === 'string') {
    price = Number.parseFloat(price);
  }

  return price || price === 0
    ? price.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : '';
};

const normalizePrice = (price, currency) => {
  let number = null;
  if (typeof price === 'number') {
    number = price;
  }

  if (typeof price === 'string') {
    if (price.indexOf(',') !== -1) {
      number = Number.parseFloat(
        price.split(' ')[0].replace('.', '').replace(',', '.').replace('€', '')
      );
    } else {
      number = Number.parseFloat(price.split(' ')[0].replace('€', ''));
    }
  }

  return number !== null
    ? number.toFixed(2).replace('.', ',') + ' ' + currency
    : '';
};

const formatGermanDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat('de-DE', {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
    .format(date)
    .replace(',', '');
};

export { formatPrice, normalizePrice, formatGermanDate };
